import { useCallback } from 'react';

import { LOGIN_REQUIRED_PATH } from '~/routes/paths';
import { useAppHistory } from '~/utilities/routing';

export function useRedirectToLogin(): () => void {
  const history = useAppHistory();

  return useCallback(() => {
    history.push(LOGIN_REQUIRED_PATH);
  }, [history]);
}
